// 新协议
function kkmhhybrid_execute_tasks(opt) {
  hybrid({
    hybridParam: {
      schema: "kkmhhybrid",
      tagname: "execute_tasks",
    },
    param: {
      tasks: opt.tasks
    },
    on:false,
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

// 旧协议
function kkmh_executeTasks(opt) {
  window.kkmh && window.kkmh.executeTasks(JSON.stringify({
    tasks: opt.tasks,
  }));
}

/**
 * 客户端响应js点击事件方法 (游戏分发)<br>
 * kkmh.executeTasks，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=43387271}<br>
 * kkmhhybrid://execute_tasks，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=286458147}<br>
 * @param {Object} opt 参数对象
 * @param {Object[]} opt.tasks 任务列表
 * @param {String} opt.tasks[].type 任务动作;  0:下载；1:恢复；2:暂停；3:安装；4:打开；5:取消下载任务
 * @param {String} opt.tasks[].appId 下载任务唯一标识
 * @param {String} opt.tasks[].pName app包名
 * @param {String} opt.tasks[].appHash 客户端用来校验下载的文件
 * @param {String} opt.tasks[].pSize app包总大小 字节
 * @param {String} opt.tasks[].url  下载地址
 * @param {String} opt.tasks[].notiTitle  通知栏内容相关
 * @param {Object} opt.tasks[].track  打点参数，其中trackType为必备属性，当trackType为1时，表示需要传递与游戏相关的打点参数，
 * @param {Function} opt.callback 回调函数,旧版本无回调函数，传进去也不会执行，新版本正常执行
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function execute_tasks(opt, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion,582000);
  if (allow) {
    // 调用新协议
    kkmhhybrid_execute_tasks(opt);
  } else {
    // 调用旧协议
    kkmh_executeTasks(opt);
    
  }
}

export default execute_tasks;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/execute_tasks/index.js